"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _bs = require("react-icons/bs");

var _Button = _interopRequireDefault(require("../Button/Button"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var Drawer = function Drawer(props) {
  var show = props.show,
      children = props.children,
      title = props.title,
      onClose = props.onClose,
      width = props.width,
      onAnchor = props.onAnchor,
      showAnchor = props.showAnchor;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      isHovered = _useState2[0],
      setIsHovered = _useState2[1];

  var handleHover = function handleHover() {
    setIsHovered(true);
  };

  var handleMouseLeave = function handleMouseLeave() {
    setIsHovered(false);
  };

  var finalIcon = isHovered ? _bs.BsArrowBarRight : _bs.BsPinAngle;
  var headerClass = "d-flex align-items-center justify-content-".concat(showAnchor ? 'around' : 'start');
  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
    className: "mainMenuDrawer ".concat(show ? 'show-menu' : ''),
    style: {
      width: width
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: headerClass
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    type: "button",
    variant: "white",
    colorIcon: "primary",
    widthButton: "40px",
    sizeIcon: "20px",
    onClick: onClose,
    icon: _bs.BsChevronLeft
  }), /*#__PURE__*/_react.default.createElement("span", {
    className: "menuSideTitle"
  }, title || 'Filtros'), showAnchor && /*#__PURE__*/_react.default.createElement("div", {
    onMouseEnter: handleHover,
    onMouseLeave: handleMouseLeave
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    className: "pin-button",
    type: "button",
    variant: "light",
    colorIcon: "primary",
    widthButton: "40px",
    sizeIcon: "20px",
    onClick: onAnchor,
    icon: finalIcon,
    placement: "top",
    tooltipText: 'Anclar filtros'
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: "menu-content"
  }, children)), /*#__PURE__*/_react.default.createElement("div", {
    className: "dimmer-nav ".concat(show ? 'show-menu' : ''),
    onClick: onClose
  }));
};

Drawer.prototypes = {
  show: _propTypes.default.bool.isRequired,
  children: _propTypes.default.element,
  title: _propTypes.default.string,
  onClose: _propTypes.default.func,
  onAnchor: _propTypes.default.func,
  width: _propTypes.default.string,
  showAnchor: _propTypes.default.bool
};
Drawer.defaultProps = {
  show: false,
  children: null,
  title: '',
  onClose: null,
  onAnchor: null,
  width: '',
  showAnchor: false
};
var _default = Drawer;
exports.default = _default;